import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';

import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import styles from './addBillingTask.style';
import validationSchema from './validationSchema';

export const AddBillingTaskModal = ({
  isOpen,
  isLoading,
  assignees,
  statuses,
  onClose,
  onSubmit,
}) => {
  const resolver = yupResolver(validationSchema);

  const methods = useForm({ resolver });
  return (
    <FormProvider {...methods}>
      <Dialog
        size="md"
        open={isOpen}
        onClose={onClose}
        scroll="paper"
        fullWidth
        maxWidth="md"
        sx={styles.wrapper}
      >
        <DialogTitle sx={styles.title}>
          Add Billing Ticket
          <IconButton
            aria-label="close"
            onClick={onClose}
            disabled={isLoading}
            sx={{ ...styles.closeButton }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ ...styles.content }}>
          <form id="add-billing-form" onSubmit={methods.handleSubmit(onSubmit)}>
            <Box sx={styles.section}>
              <Box sx={styles.row}>
                <FieldV2
                  isRequired
                  label="Title"
                  type="text"
                  control={methods.control}
                  name="customFields.title"
                />
              </Box>
              <Box sx={styles.row}>
                <FieldV2
                  label="Subsciption ID"
                  type="text"
                  control={methods.control}
                  name="customFields.subscriptionId"
                />
                <FieldV2
                  label="AR&M Ticket ID"
                  type="text"
                  control={methods.control}
                  name="customFields.arnmTicket"
                />
                <FieldV2
                  isRequired
                  label="Assignee"
                  type="autocomplete"
                  options={assignees || []}
                  control={methods.control}
                  name="assignee"
                />
                <FieldV2
                  isRequired
                  label="Stage"
                  type="autocomplete"
                  options={statuses || []}
                  control={methods.control}
                  name="status"
                />
              </Box>
            </Box>
            <Box sx={styles.section}>
              <Box sx={styles.row}>
                <FieldV2
                  rows="3"
                  label="Description"
                  type="text"
                  multiline
                  control={methods.control}
                  name="customFields.description"
                />
              </Box>
            </Box>
            <DialogActions sx={{ ...styles.footer }}>
              <ButtonV2 type="button" variant="outlined" onClick={onClose}>
                Cancel
              </ButtonV2>
              <ButtonV2
                form="add-billing-form"
                type="submit"
                disabled={
                  isLoading ||
                  !methods.formState.isValid ||
                  methods.formState.isSubmitting
                }
              >
                Add
              </ButtonV2>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </FormProvider>
  );
};

export default AddBillingTaskModal;
